export default __webpack_public_path__ + "static/bg-innovation-da73ba3f3dde6ac12715e5e60798ee1b.webp";